import { motion } from "framer-motion";
import { Flower2 } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Marquee = ({ items }) => (
    <div className="overflow-hidden border-y border-border bg-sand py-5" data-testid="editorial-marquee">
        <div className="animate-marquee flex w-max items-center gap-12">
            {[...items, ...items].map((item, i) => (
                <span key={i} className="flex items-center gap-12 whitespace-nowrap">
                    <span className="font-serif text-2xl font-light italic text-bark/80">{item}</span>
                    <Flower2 className="h-4 w-4 text-sage" strokeWidth={1.5} />
                </span>
            ))}
        </div>
    </div>
);

export const Overline = ({ children, className = "" }) => (
    <p className={`text-xs font-medium uppercase tracking-[0.28em] text-sage ${className}`}>{children}</p>
);
